var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "d-flex justify-space-between",
      attrs: { id: "monitor-table-set" }
    },
    [
      _c(
        "div",
        { staticClass: "monitor-table-set__container" },
        _vm._l(_vm.option_set, function(value, index) {
          return _c("MonitorOption", {
            key: index,
            attrs: {
              label: value.label,
              current_option: value.current_option_value,
              options: value.option_array,
              description: value.description
            },
            on: { change_filter_option_value: _vm.change_filter_option_value }
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm._t("remarks")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }